import React, { useState, useEffect } from 'react';
import '@css/crud-buttons.css'
import { useSelector } from 'react-redux';

export default function CrudButtons() {

  const permissions = useSelector(state => state.pageAuth);
  const activeTab = useSelector(state => state.tabs.activeTab);
  const [actions, setActions] = useState(null);

  useEffect(() => {
    const interval = setInterval(() => {
      if (window.currentCrudActions?.[activeTab]) {
        setActions(window.currentCrudActions[activeTab]);
      }
    }, 50);

    return () => clearInterval(interval);
  }, [activeTab]);

  if (!permissions || !activeTab) return null;

  const { rtv, add, save, del } = permissions;

  const handleClick = (type) => () => {
    const action = actions?.[type];
    if (action) action();
    else console.warn(`[${activeTab}] ${type} 액션 미등록`);
  };

  return (
    <div className='crud-buttons'>
      {rtv && actions?.rtv && (
        <button type="button" className="crud-btn rtv-btn" id="crudRtv" title="F5" onClick={handleClick('rtv')}>
          <i className='bx bx-search'></i> 조회
        </button>
      )}
      {add && actions?.add && (
        <button type="button" className="crud-btn add-btn" id="crudAdd" title="F2" onClick={handleClick('add')}>
          <i className='bx bx-plus-circle'></i> 추가
        </button>
      )}
      {save && actions?.save && (
        <button type="button" className="crud-btn save-btn" id="crudSave" title="F3" onClick={handleClick('save')}>
          <i className='bx bx-save'></i> 저장
        </button>
      )}
      {del && actions?.del && (
        <button type="button" className="crud-btn del-btn" id="crudDel" title="F4" onClick={handleClick('del')}>
          <i className='bx bx-trash'></i> 삭제
        </button>
      )}
    </div>
  );
}
